import type { KyrgyzstanOwnerOrder } from 'shared/api/kyrgyzstan/webview-owner'
import { DATE_FORMAT_LIST } from 'shared/constants/dateFormatList'
import { dateFormat } from 'shared/lib/dateFormat'

import type { ObjectApplication } from '../model/types'

export const mapOwnerOrderToObjectApplication = (
  order: KyrgyzstanOwnerOrder,
): ObjectApplication => ({
  id: order.id,
  title: order.object.title,
  address: order.object.address,
  startDate: dateFormat(
    order.start_date,
    DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR,
  ),
  endDate: dateFormat(order.end_date, DATE_FORMAT_LIST.FULL_DATE_SHORT_YEAR),
  nightsCount: order.nights,
  guestsCount: order.visitors_count,
})
